import { effect, inject, Injectable, signal } from '@angular/core';
import { OpkraevningDatasource } from './opkraevning.datasource';
import { Opkraevning } from './opkraevning.model';
import { OpkraevningsListerService } from '@features/opkraevningslister/opkraevningslister.service';

@Injectable({
  providedIn: 'root',
})
export class OpkraevningService {
  datasource = inject(OpkraevningDatasource);
  opkraevningsListerService = inject(OpkraevningsListerService);

  constructor() {
    effect(() => {
      if (this.datasource.isLoaded()) {
        const data = this.datasource.data();
        if (data && data.totalRowCount > 0) {
          this.activeTab.set('result');
        }
      }
    });
  }

  selectedOpkraevning = signal<Opkraevning | undefined>(undefined);
  activeTab = signal('search');

  // searchOpkraevning(searchParams: OpkraevningSearchParams) {
  //   this.selectedOpkraevning.set(undefined);
  //   this.datasource.searchParams.set(searchParams);
  //   this.datasource.loadData();
  // }

  async selectOpkraevningResultRow(opkraevning: Opkraevning) {
    await this.selectOpkraevning(opkraevning);

    if (opkraevning) {
      this.activeTab.set('detail');
    }
  }

  async selectOpkraevning(opkraevning: Opkraevning) {
    const k = await this.datasource.getById(opkraevning.id!);
    this.selectedOpkraevning.set(k);
    this.opkraevningsListerService.activeTab.set('opkraevning');
  }
}
